import { UPDATE_ACTIVE_ITEM } from "../types/globalTypes";

const globalInitialState = {
  activeItem: "home"
};
export const globalReducer = (state = globalInitialState, action) => {
  switch (action.type) {
    case UPDATE_ACTIVE_ITEM:
      return { ...state, activeItem: action.payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/globalReducer.js